import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Container from "@mui/material/Container";
import axios from "axios";
import Divider from "@mui/material/Divider";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import Alert from "@mui/material/Alert";
// import { FormContainer, TextFieldElement } from "react-hook-form-mui";

const FormTeam = props => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { api, comp } = itemOptions;
    const { t } = i18n;
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const [code, setCode] = useState("");
    let { state } = useLocation();
    useEffect(() => {
        setCode(state.code);
    }, []);
    const {
        handleSubmit,
        control,
        watch,
        reset,
        register,
        formState: { errors, isValid }
    } = useForm({
        defaultValues: {
            team: "",
            email: "",
            country: "",
            city: "",
            club: "",
            teamMembers: [{ name: "", surname: "", yearOfBirth: "" }]
        }
    });

    const { fields, append, prepend, remove, swap, move, insert } = useFieldArray({
        control, // control props comes from useForm (optional: if you are using FormContext)
        name: "teamMembers" // unique name for your Field Array
    });
    useEffect(() => {
        setLoading(true);
        append({ name: "", surname: "", yearOfBirth: "" });
        axios
            .get(`${api.getCountryList}`)
            .then(res => {
                if (res.status === 200) {
                    let tmp = [];
                    res.data.forEach(element => {
                        tmp.push({ label: element.name, id: element.id });
                    });
                    reset({
                        team: "",
                        email: "",
                        city: "",
                        club: "",
                        country: "Poland",
                        teamMembers: [{ name: "", surname: "", yearOfBirth: "" }]
                    });
                    setCountries(tmp);
                }
            })
            .catch(function(error) {
                console.log(error);
            });
        setLoading(false);
    }, []);
    const onSubmit = data => {
        if (isValid || Object.entries(errors).length === 0) {
            navigate("/categories", {
                state: {
                    firstName: null,
                    lastName: null,
                    yearOfBirth: data.year,
                    firstName2: null,
                    lastName2: null,
                    idCountry: data.country,
                    year2: null,
                    city: data.city,
                    club: data.club,
                    couple: null,
                    team: data.team,
                    teamMembers: data.teamMembers,
                    email: data.email,
                    fromWdsf: false,
                    fromForm: true,
                    isSolo: false,
                    isCouple: false,
                    isTeam: true,
                    code: code
                }
            });
        } else {
            console.log(errors);
        }
    };
    const onError = (errors, e) => {
        console.log(errors);
    };

    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.wdsf.team")}</h2>
            <p>{t("reg.info.form.couple")}</p>
            {!loading && (
                <Container maxWidth="lg" className="mb-2">
                    <Box>
                        <form onSubmit={handleSubmit(onSubmit, onError)}>
                            <Stack direction="column" spacing={{ xs: 1, sm: 1, md: 2 }}>
                                <Controller
                                    name="team"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={`${t("reg.team_name")}`}
                                            type="text"
                                            required
                                            error={errors.lastName !== undefined}
                                            helperText={errors.lastName !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        />
                                    )}
                                />
                                <Divider />

                                <Controller
                                    name="city"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("city")}
                                            type="text"
                                            required
                                            error={errors.city !== undefined}
                                            helperText={errors.city !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="club"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("club")}
                                            type="text"
                                            required
                                            error={errors.club !== undefined}
                                            helperText={errors.club !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="country"
                                    control={control}
                                    render={({ field }) => (
                                        <FormControl fullWidth sx={{ textAlign: "left" }}>
                                            <InputLabel id="country-label">{t("country")}</InputLabel>
                                            <Select {...field} labelId="country-label" label={t("country")}>
                                                {countries.map(c => (
                                                    <MenuItem key={c.id} value={c.label}>
                                                        {c.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    )}
                                />
                                <Controller
                                    name="email"
                                    control={control}
                                    rules={{
                                        pattern: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("email")}
                                            type="email"
                                            required
                                            error={errors.email !== undefined}
                                            helperText={errors.email !== undefined ? t("reg.wdsf.helper.email") : ""}
                                        />
                                    )}
                                />
                                <Typography sx={{ textAlign: "left" }}>{t("starters.formation.dancers")}:</Typography>
                                {fields.map((field, index) => (
                                    <Stack direction="row" key={field.id} sx={{ alignItems: "center" }} spacing={1}>
                                        <Typography variant="button">{index + 1}</Typography>
                                        <Controller
                                            name={`teamMembers.${index}.name`}
                                            control={control}
                                            defaultValue=""
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    label={`${t("first_name")}`}
                                                    type="text"
                                                    required

                                                    // error={errors.lastName !== undefined}
                                                    // helperText={errors.lastName !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                                />
                                            )}
                                        />
                                        <Controller
                                            name={`teamMembers.${index}.surname`}
                                            control={control}
                                            defaultValue=""
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    label={`${t("last_name")}`}
                                                    type="text"
                                                    required
                                                    // error={errors.lastName !== undefined}
                                                    // helperText={errors.lastName !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                                />
                                            )}
                                        />
                                        <Controller
                                            name={`teamMembers.${index}.yearOfBirth`}
                                            control={control}
                                            rules={{ required: true, min: 1900, max: 2099 }}
                                            defaultValue=""
                                            render={({ field }) => (
                                                <TextField
                                                    {...field}
                                                    label={`${t("reg.birth_year")}`}
                                                    type="number"
                                                    min="1900"
                                                    max="2099"
                                                    step="1"
                                                    required
                                                    // error={errors.year !== undefined}
                                                    // helperText={errors.year !== undefined ? t("reg.wdsf.helper.not_empty") : ""}
                                                />
                                            )}
                                        />
                                        <IconButton aria-label="delete" onClick={() => remove(index)}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Stack>
                                ))}
                                <Stack direction="row">
                                    <Button
                                        aria-label="add"
                                        variant="outlined"
                                        startIcon={<PersonAddIcon />}
                                        onClick={() => append({ name: "", surname: "", yearOfBirth: "" })}
                                    >
                                        {t("add_athlete")}
                                    </Button>
                                </Stack>
                                {fields.length < 3 && <Alert severity="warning">{t("reg.info.form.team_number")}</Alert>}
                                {!loading && fields.length >= 3 && (
                                    <Button type="submit" variant="outlined">
                                        {t("confirm_proceed_to_categories")}
                                    </Button>
                                )}
                                {loading && <LinearProgress />}
                            </Stack>
                        </form>
                    </Box>
                </Container>
            )}
        </React.Fragment>
    );
};

export default FormTeam;
